import { useEffect, useState } from 'react';
import { base44 } from '@/api/base44Client';
import { isCaseOpen, isCaseOverdue } from '@/lib/caseQueue';

// Live open / overdue case counts for the admin navigation badge. Stays current
// through the entity subscription rather than polling, matching the unread-email
// hook. Returns zeros for non-admins (the entity is admin-only).
export default function useCaseCounts(enabled = true) {
  const [counts, setCounts] = useState({ open: 0, overdue: 0 });

  useEffect(() => {
    if (!enabled) {
      setCounts({ open: 0, overdue: 0 });
      return;
    }
    let cancelled = false;

    const load = async () => {
      try {
        const rows = await base44.entities.Case.list('-last_activity_at', 500);
        if (cancelled) return;
        const open = (rows || []).filter(isCaseOpen);
        setCounts({
          open: open.length,
          overdue: open.filter((c) => isCaseOverdue(c)).length,
        });
      } catch {
        if (!cancelled) setCounts({ open: 0, overdue: 0 });
      }
    };

    load();
    const unsubscribe = base44.entities.Case.subscribe(() => load());
    return () => {
      cancelled = true;
      if (typeof unsubscribe === 'function') unsubscribe();
    };
  }, [enabled]);

  return counts;
}